<div class="page-container gap-24">
  <div class="page-title justify-space-between">
    <span class="font-bold-display-medium"> Fortbildungen Kategorie </span>
    <div>
      <button
        class="inwi-text-icon-button-medium-outline"
        (click)="aboutMenu.toggle($event)">
        <div class="button-content">
          <div class="button-text">Fortbildungs Optionen</div>
          <div class="button-icon">
            @if (aboutMenu.visible) {
              <i class="fa-regular fa-chevron-up"></i>
            } @else {
              <i class="fa-regular fa-chevron-down"></i>
            }
          </div>
        </div>
      </button>
      <p-menu #aboutMenu [model]="optionMenuItems" [popup]="true"> </p-menu>
    </div>
  </div>
  <app-table-header-navigation
    [isLoading]="isLoading"
    [slides]="cardSlides"
    (cardClicked)="onCardClicked($event)"></app-table-header-navigation>

  <div class="page-title">
    <span class="title-content">
      <i class="fa-regular fa-eye font-medium-display-small"></i>
      <span class="font-medium-display-small"> Vorschau </span>
    </span>
  </div>
  <div class="flex-c gap-24 padding-bottom-24">
    @if (isLoading) {
      <p-skeleton width="100%" height="316px" borderRadius="12px"></p-skeleton>
      <p-skeleton width="500px" height="465px" borderRadius="12px"></p-skeleton>
      <p-skeleton width="288px" height="268px" borderRadius="12px"></p-skeleton>
      <p-skeleton width="288px" height="87px" borderRadius="12px"></p-skeleton>
    } @else {
      <app-title-card [titleCard]="titleCard"></app-title-card>
      <app-topic-card
        [topicCard]="topicCard"
        class="topic-card"></app-topic-card>
      <app-card [card]="slide"></app-card>
      <app-card-header-navigation
        [card]="slideHeaderNavigation"></app-card-header-navigation>
    }
  </div>
</div>
